import { render, staticRenderFns } from "./changedata.vue?vue&type=template&id=2b0757d9&scoped=true"
import script from "./changedata.vue?vue&type=script&lang=js"
export * from "./changedata.vue?vue&type=script&lang=js"
import style0 from "./changedata.vue?vue&type=style&index=0&id=2b0757d9&prod&scoped=true&lang=scss"
import style1 from "./changedata.vue?vue&type=style&index=1&id=2b0757d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0757d9",
  null
  
)

export default component.exports